export default [
  {
    title: 'Dashboard',
    route: 'home',
    icon: 'HomeIcon',
    resource: 'APP_DASHBOARD',
    action: 'read',
  },
  {
    title: 'Satıcı Kartları',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Ekle',
        route: 'SuppliersAdd',
        resource: 'APP_SUPPLIER_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'suppliers',
        resource: 'APP_SUPPLIERS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Müşteri Kartları',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Ekle',
        route: 'CustomersAdd',
        resource: 'APP_CUSTOMER_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'customers',
        resource: 'APP_CUSTOMERS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Teklif Yönetimi',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Ekle',
        route: 'OffersAdd',
        resource: 'APP_OFFER_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'offers',
        resource: 'APP_OFFERS',
        action: 'read',
      },
    ],
  },
  {
    title: 'Servis Yönetimi',
    icon: 'TruckIcon',
    children: [
      {
        title: 'Ekle',
        route: 'ServiceCustomerSearchAdd',
        resource: 'APP_SERVICE_ADD',
        action: 'read',
      },
      {
        title: 'Listele',
        route: 'Services',
        resource: 'APP_SERVICES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Ürün Yönetimi',
    icon: 'PackageIcon',
    children: [
      {
        title: 'Fiyat Listesi',
        route: 'products',
        resource: 'APP_PRODUCTS',
        action: 'read',
      },
      {
        title: 'Ürün Grupları',
        route: 'product_types',
        resource: 'APP_PRODUCT_TYPES',
        action: 'read',
      },
      {
        title: 'Markalar',
        route: 'brands',
        resource: 'APP_PRODUCT_BRANDS',
        action: 'read',
      },
    ],
  },
  {
    title: 'İnsan Kaynakları',
    icon: 'UserCheckIcon',
    children: [
      {
        title: 'Personel Kartları',
        route: 'Employees',
        resource: 'APP_EMPLOYESS',
        action: 'read',
      },
      {
        title: 'Tanımlamalar',
        children: [
          {
            title: 'Bankalar',
            route: 'hrBanks',
          },
          {
            title: 'Kan Grupları',
            route: 'hrBloodGroup',
          },
          {
            title: 'Engel Durumları',
            route: 'hrDisabilities',
          },
          {
            title: 'Eğitim Seviyeleri',
            route: 'hrEducationLevels',
          },
          {
            title: 'Eğitim Durumları',
            route: 'hrEducationalStatuses',
          },
          {
            title: 'Personel Ödeme Tipleri',
            route: 'hrEmployeePaymentTypes',
          },
          {
            title: 'Personel Görevleri',
            route: 'hrEmployeeTasks',
          },
          {
            title: 'Cinsiyetler',
            route: 'hrGenders',
          },
          {
            title: 'Medeni Durumlar',
            route: 'hrMaritals',
          },
          {
            title: 'İzin Tipleri',
            route: 'hrPermitTypes',
          },
          {
            title: 'Maaş Dönemleri',
            route: 'hrSalaryPeriods',
          },
        ],
        resource: 'APP_HR_DEFINES',
        action: 'read',
      },
    ],
  },
  {
    title: 'Tanımlamalar',
    icon: 'DatabaseIcon',
    children: [
      {
        title: 'Şehir',
        route: 'cities',
        resource: 'APP_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'İlçe',
        route: 'districts',
        resource: 'APP_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Temas',
        route: 'meets',
        resource: 'APP_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Sektör',
        route: 'sectors',
        resource: 'APP_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Departman',
        route: 'departments',
        resource: 'APP_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Para Birimleri',
        route: 'currencies',
        resource: 'APP_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Birim Tipleri',
        route: 'units',
        resource: 'APP_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Teklif Özel Şartları',
        route: 'offer_terms',
        resource: 'APP_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Servis Hizmet Şekilleri',
        route: 'ServiceTypes',
        resource: 'APP_DEFINES_ALL',
        action: 'read',
      },
      {
        title: 'Servis Personeli',
        route: 'Workers',
        resource: 'APP_DEFINES_ALL',
        action: 'read',
      },
    ],
  },
  {
    title: 'Sistem',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Kullanıcılar',
        route: 'Users',
        resource: 'APP_USERS',
        action: 'read',
      },
      {
        title: 'Kullanıcı Tipleri',
        route: 'UserTypes',
        resource: 'APP_USER_TYPES',
        action: 'read',
      },
      {
        title: 'SMTP Ayaları',
        route: 'Smtp',
        resource: 'APP_SMTP',
        action: 'read',
      },
    ],
  },
]
